import React, { useEffect, useState } from 'react';
import { X, Plus } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';

/* Las etiquetas de un lead, para ponerlas sin salir de la charla (pedido de
   Punto Reciclaje: sectorizar los leads mientras se habla con ellos).

   Se elige una de las que ya existen o, si no está, se escribe y se crea en el
   mismo momento. La lista de existentes se pide al abrir, así lo que creó otra
   persona del equipo aparece sin recargar la pantalla. */
export default function EtiquetasLead({ leadId, etiquetas = [], onCambio }) {
  const [todas, setTodas] = useState([]);
  const [texto, setTexto] = useState('');
  const [guardando, setGuardando] = useState(false);

  const cargarTodas = () => api.get('/leads/meta/tags').then(r => setTodas(r.data || [])).catch(() => {});
  useEffect(() => { cargarTodas(); }, [leadId]);

  const puestas = new Set(etiquetas.map(e => e.name.toLowerCase()));
  const q = texto.trim().toLowerCase();
  const sugeridas = todas.filter(t => !puestas.has(t.name.toLowerCase()) && (!q || t.name.toLowerCase().includes(q)));
  const esNueva = q && !todas.some(t => t.name.toLowerCase() === q);

  const agregar = async (nombre) => {
    const n = String(nombre || '').trim();
    if (!n || guardando) return;
    if (puestas.has(n.toLowerCase())) { setTexto(''); return; }
    setGuardando(true);
    try {
      await api.post(`/leads/${leadId}/tags`, { tag_name: n });
      setTexto(''); cargarTodas(); onCambio && onCambio();
    } catch { toast.error('No se pudo agregar la etiqueta'); }
    finally { setGuardando(false); }
  };
  const sacar = async (tag) => {
    try { await api.delete(`/leads/${leadId}/tags/${tag.id}`); cargarTodas(); onCambio && onCambio(); }
    catch { toast.error('No se pudo sacar la etiqueta'); }
  };

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, margin: '4px 0 8px' }}>
        {etiquetas.length === 0 && <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Sin etiquetas</span>}
        {etiquetas.map(t => (
          <span key={t.id} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 6px 3px 10px', borderRadius: 99, fontSize: 12, fontWeight: 600, background: 'var(--accent-soft)', color: 'var(--accent)' }}>
            {t.name}
            <button onClick={() => sacar(t)} title="Sacar etiqueta" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', padding: 0, display: 'flex' }}><X size={13} /></button>
          </span>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 6 }}>
        <input value={texto} onChange={e => setTexto(e.target.value)} maxLength={50}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); agregar(sugeridas.find(t => t.name.toLowerCase() === q)?.name || texto); } }}
          placeholder="Elegí o creá una etiqueta" style={{ flex: 1, fontSize: 13, padding: '6px 10px' }} />
        <button className="btn btn-ghost btn-sm" onClick={() => agregar(texto)} disabled={!q || guardando} title="Agregar" style={{ padding: '4px 8px' }}><Plus size={15} /></button>
      </div>
      {(sugeridas.length > 0 || esNueva) && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginTop: 6 }}>
          {esNueva && <button onClick={() => agregar(texto)} style={chip(true)}>+ Crear "{texto.trim()}"</button>}
          {sugeridas.slice(0, 12).map(t => <button key={t.id} onClick={() => agregar(t.name)} style={chip(false)}>{t.name}</button>)}
        </div>
      )}
    </div>
  );
}

const chip = (nueva) => ({
  padding: '3px 9px', borderRadius: 99, fontSize: 12, cursor: 'pointer',
  border: '1px dashed ' + (nueva ? 'var(--accent)' : 'var(--border)'),
  background: 'transparent', color: nueva ? 'var(--accent)' : 'var(--text-secondary, var(--text-muted))',
});
